import { Model } from 'json-api-models';

import { Models, QuestionSession, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

/**
 * Question relationships revealed once an attempt is finalized.
 *
 * Answer responses include these so the question workspace can show the
 * result without loading the attempt again.
 */
export const FINALIZED_QUESTION_INCLUDE = [
    'activeRevision.explanationMedia',
    'item.activeRevision',
    'item.contributions.user.institution',
    'item.contributions.contributionType',
];

export class QuestionAttempt extends Model<Schemas['questionAttempts'], Models> {
    get startedAtDate() {
        return nullableDate(this.startedAt);
    }

    get answeredAtDate() {
        return nullableDate(this.answeredAt);
    }

    get finalizedAtDate() {
        return nullableDate(this.finalizedAt);
    }

    get isComplete(): boolean {
        const revision = this.question?.activeRevision;
        const session = this.session;
        const isFinishedExam =
            session instanceof QuestionSession && session.isExam && session.finishedAt;
        return Boolean(
            isFinishedExam ||
            (this.finalizedAt && !revision?.answersIncrementally) ||
            (revision?.answersIncrementally &&
                revision.correctOptions?.every((i) => this.options?.includes(i))),
        );
    }

    get resultAvailable(): boolean {
        return Boolean(
            this.finalizedAt &&
            (!(this.session instanceof QuestionSession) || this.session.resultsAvailable),
        );
    }
}
